import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		scope:                      {
			totals:   '=',
			column:   '@?dtFooter',
			places:   '<?',
			prefix:   '@?',
			suffix:   '@?',
			splitter: '@?',
		},
		controller: /* @ngInject */ ($scope, $rootScope) => {
			if (typeof $scope.places === 'undefined') {
				$scope.places = 0;
			}

			if (typeof $scope.prefix === 'undefined') {
				$scope.prefix = '';
			}

			if (typeof $scope.splitter === 'undefined') {
				$scope.splitter = '/';
			}

			const unsubscribe = $rootScope.$on('dataTablesService.updated', (event, id) => {
				if (id === $scope.totals.id) {
					$scope.$apply(() => {
						$scope.page  = $scope.totals.page[$scope.column];
						$scope.total = $scope.totals.total[$scope.column];
					});
				}
			});

			$scope.$on('destroy', () => {
				unsubscribe();
			});
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/dtFooter/index.js